<lin-progress-bar [isShown]="!dataSource || (dataSource.isLoading$ | async)"></lin-progress-bar>
<form [formGroup]="form">
  <lin-table [dataSource]="dataSource || []" matSort>
    <!-- picture Column -->
    <ng-container matColumnDef="picture">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon"> {{ 'FIELDS.picture' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let user" class="g-table-column-icon">
        <lin-avatar [source]="user.picture" [name]="user.name" [surName]="user.surname" [size]="AvatarSize.sm"></lin-avatar>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="picture-search">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon"></mat-header-cell>
    </ng-container>

    <!-- User Name Column -->
    <lin-table-column name="fullName" [label]="view !== 'client' ? ('FIELDS.DRIVER_NAME' | translate) : null" sticky>
      <ng-container *matCellDef="let user">
        @if (!(view === 'client' && isManager)) {
          <lin-cell-link [routerLink]="getEditUserLink(user.id)">
            {{ user.fullName }}
          </lin-cell-link>
        } @else {
          <lin-cell-text>{{ user.fullName }}</lin-cell-text>
        }
      </ng-container>
    </lin-table-column>

    <lin-table-header-control name="fullName-search" sticky>
      <input matInput formControlName="fullName" autocomplete="off" />
    </lin-table-header-control>

    <!-- E-mail Column -->
    <lin-table-column name="email">
      <lin-cell-text *ng="let user">{{ user.email }}</lin-cell-text>
    </lin-table-column>

    <lin-table-header-control name="email-search">
      <input matInput formControlName="email" autocomplete="off" />
    </lin-table-header-control>

    <!-- DriverID Column -->
    <lin-table-column name="driverId">
      <lin-cell-text *ng="let user">{{ user.driverId }}</lin-cell-text>
    </lin-table-column>

    <lin-table-header-control name="driverId-search">
      <input matInput formControlName="driver_id" autocomplete="off" />
    </lin-table-header-control>

    <!-- driverFOBId Column -->
    <lin-table-column name="driverFobId" [label]="'ADMIN.CLIENTS.USERS.DRIVER_FOB_ID' | translate">
      <lin-cell-text *ng="let user">{{ user.driverFobId }}</lin-cell-text>
    </lin-table-column>

    <lin-table-header-control name="driverFobId-search">
      <input matInput formControlName="driverFobId" autocomplete="off" />
    </lin-table-header-control>

    <!-- Role Column -->
    <lin-table-column name="role" [label]="'CLIENT.USERS.ROLE' | translate">
      <lin-cell-text *ng="let user"> {{ user.role?.displayName + (user.isDualAccount ? '/Driver' : '') }} </lin-cell-text>
    </lin-table-column>

    @if (isClientView) {
      <lin-table-header-control name="role-search">
        <mat-select formControlName="role">
          <mat-option></mat-option>
          @for (role of roles; track role.name) {
            <mat-option [value]="role.name">{{ role.displayName }}</mat-option>
          }
        </mat-select>
      </lin-table-header-control>
    }

    <!-- driverSensorId Column -->
    <lin-table-column name="driverSensorId">
      <lin-cell-text *ng="let user">{{ user.driverSensorId }}</lin-cell-text>
    </lin-table-column>

    <ng-container matColumnDef="driverSensorId-search">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
    </ng-container>

    <!-- phone Column -->
    <lin-table-column name="phone" label="FIELDS.phoneShort">
      <lin-cell-text *ng="let user">{{ user.phone }}</lin-cell-text>
    </lin-table-column>

    <ng-container matColumnDef="phone-search">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
    </ng-container>

    <!-- position Column -->
    <lin-table-column name="position">
      <lin-cell-text *ng="let user">{{ user.position }}</lin-cell-text>
    </lin-table-column>

    <ng-container matColumnDef="position-search">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
    </ng-container>

    <!-- Last Logged Date Column -->
    <lin-table-column name="last_logged_at" [label]="'CLIENT.USERS.LAST_LOGIN_DATE' | translate">
      <lin-cell-text *ng="let user"> {{ (user.lastLoggedAt | dayjsDateTime) || '-' }} </lin-cell-text>
    </lin-table-column>

    <ng-container matColumnDef="last_logged_at-search">
      <mat-header-cell *matHeaderCellDef>
        <lin-datepicker-field formControlName="last_logged_at" [isRange]="true" [isWithTimePicker]="true"></lin-datepicker-field>
      </mat-header-cell>
    </ng-container>

    <!-- Status Column -->
    <lin-table-column name="status">
      <lin-cell-text *ng="let user"> {{ user.status | titlecase }} </lin-cell-text>
    </lin-table-column>

    <lin-table-header-control name="status-search">
      <mat-select formControlName="status">
        <mat-option></mat-option>
        @for (status of statuses; track status.name) {
          <mat-option [value]="status.name">{{ status.displayName }}</mat-option>
        }
      </mat-select>
    </lin-table-header-control>

    <!-- Edit Column -->
    <ng-container matColumnDef="edit">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon">{{ 'CLIENT.USERS.EDIT' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let user" class="g-table-column-icon">
        <button
          mat-icon-button
          [routerLink]="getEditUserLink(user.id)"
          [matTooltip]="'CLIENT.USERS.EDIT' | translate"
          aria-label="Edit user"
          data-testid="btn-edit-user"
        >
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="edit-search">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon"></mat-header-cell>
    </ng-container>

    <!-- Send a message Column -->
    <ng-container matColumnDef="sendMessageLink">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon">{{ 'CLIENT.USERS.SEND_MESSAGE_LINK' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let user" class="g-table-column-icon">
        <button
          mat-icon-button
          [matTooltip]="'CLIENT.USERS.SEND_MESSAGE_LINK' | translate"
          (click)="sendEmail(user)"
          aria-label="Send message"
          data-testid="btn-send-message-user"
        >
          <mat-icon svgIcon="mail_outline"></mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="sendMessageLink-search">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon"></mat-header-cell>
    </ng-container>

    <!-- Impersonate link Column -->
    <ng-container matColumnDef="impersonate">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon">{{ 'ADMIN.ADMIN_TEAM.IMPERSONATE' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let user" class="g-table-column-icon">
        <button
          mat-icon-button
          (click)="authService.impersonateAsUser(user.id)"
          [matTooltip]="'ADMIN.ADMIN_TEAM.IMPERSONATE' | translate"
          aria-label="Impersonate user"
          data-testid="btn-impersonate-user"
        >
          <mat-icon svgIcon="transfer_within_a_station"></mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="impersonate-search">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon"></mat-header-cell>
    </ng-container>

    <!-- Archive Link Column -->
    <ng-container matColumnDef="archiveLink">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon">{{ 'CLIENT.USERS.ARCHIVE_LINK' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let user" class="g-table-column-icon">
        @if (isProcessing[user.id]) {
          <mat-spinner strokeWidth="2" diameter="20" color="accent"></mat-spinner>
        }
        @if (canDeleteOrArchiveUser(user, 'ARCHIVE')) {
          @if (user.isArchived()) {
            <button
              mat-icon-button
              type="button"
              (click)="restoreUser(user.id)"
              [matTooltip]="'CLIENT.USERS.RESTORE_LINK' | translate"
              aria-label="Restore user"
              data-testid="btn-unarchive-user"
            >
              <mat-icon>unarchive</mat-icon>
            </button>
          } @else {
            <button
              mat-icon-button
              type="button"
              (click)="archiveUser(user)"
              [matTooltip]="'CLIENT.USERS.ARCHIVE_LINK' | translate"
              aria-label="Archive user"
              data-testid="btn-archive-user"
            >
              <mat-icon>archive</mat-icon>
            </button>
          }
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="archiveLink-search">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon"></mat-header-cell>
    </ng-container>

    <!-- Delete link Column -->
    <ng-container matColumnDef="deleteLink">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon">{{ 'CLIENT.USERS.DELETE_LINK' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let user" class="g-table-column-icon">
        @if (isProcessing[user.id]) {
          <mat-spinner strokeWidth="2" diameter="20" color="accent"></mat-spinner>
        }
        @if (canDeleteOrArchiveUser(user, 'DELETE')) {
          <button
            mat-icon-button
            type="button"
            (click)="deleteUser(user)"
            [matTooltip]="'CLIENT.USERS.DELETE_LINK' | translate"
            aria-label="Delete user"
            data-testid="btn-delete-user"
          >
            <mat-icon svgIcon="delete"></mat-icon>
          </button>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="deleteLink-search">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon"></mat-header-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="settings.columnsDisplayed; sticky: true"></mat-header-row>
    <mat-header-row *matHeaderRowDef="settings.columnsSearchDisplayed; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: settings.columnsDisplayed"></mat-row>
  </lin-table>

  <lin-table-toolbar>
    <lin-table-toolbar-button-row>
      @if (isAddMode) {
        <button type="button" mat-raised-button color="accent" routerLink="./new">
          {{ (view === 'driver' ? 'ADMIN.CLIENTS.USERS.ADD_DRIVER' : 'ADMIN.CLIENTS.USERS.ADD_USER') | translate }}
        </button>
      }

      <mat-checkbox formControlName="showArchived">{{ 'CLIENT.USERS.SHOW_ARCHIVED' | translate }}</mat-checkbox>
    </lin-table-toolbar-button-row>
    <mat-paginator linPaginatorDefault></mat-paginator>
  </lin-table-toolbar>
</form>

<lin-table-settings #settings [columns]="columns" [columnsMandatory]="columnsMandatory" [disableExportPDF]="true"></lin-table-settings>
